import type {AiPromptBoxSize} from "@Components/ai-prompt-box/ai-prompt-box.types";
import type {DocumentAttachment, PendingUpload} from "@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types";
import {PendingUploadStatus} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import {DocumentChipStep} from '@Components/document-chip/document-chip.types';

export const DOCUMENT_CHIP_STEP_BY_STATUS: Partial<Record<PendingUploadStatus, DocumentChipStep>> = {
  [PendingUploadStatus.UPLOADING]: DocumentChipStep.UPLOADING,
  [PendingUploadStatus.PROCESSING]: DocumentChipStep.READING,
};

export interface AiPromptBoxAttachmentPreviewProps {
	previewUrl: string;
	index: number;
	onRemove: (index: number) => void;
	onPreviewClick: (index: number) => void;
	onRetry?: (index: number) => void;
	size: AiPromptBoxSize;
	pendingUpload?: PendingUpload;
	isRemovalLocked?: boolean;
	documentAttachment?: Pick<DocumentAttachment, 'filename' | 'documentType'>;
}
